import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Api grid loading component.
 *
 * @author Mikhail Siutsou
 * @function ApiGridLoading
 * @category components
 * @return {ReactNode} children.
 */
function ApiGridLoading(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}

ApiGridLoading.displayName = 'ApiGridLoading';
export { ApiGridLoading };